/** @format */

export const DEFAULT_TEST_ID = 'kit-feedback';

/**
 * The datalayer event a verdict on this section is reported as.
 *
 * Declared here rather than added to `client/global/analytics`, the same as
 * the fan's own feedback event, so that nothing outside `beta-model-insights`
 * has to know this experiment exists.
 */
export const KIT_INTELLIGENCE_FEEDBACK = 'KIT_INTELLIGENCE_FEEDBACK';

export enum KitFeedbackVerdict {
    USEFUL = 'useful',
    NOT_USEFUL = 'not_useful',
}
